import { useContext, useState } from "react";

import type { AnimationEffectProps } from "./types";
import { ScrollTimeline } from "../../displayComponents/displayElements/DisplayElements";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";

gsap.registerPlugin(ScrollTrigger);

function useScrollAnimation({
    elRef,
    pageIndex,
    isInAuthor,
    isPreviewer,
    isInPlayWrightTest,
    navigationType,
    scrollerRef
}: AnimationEffectProps): gsap.core.Timeline | undefined {
    const scrollTimeline = useContext(ScrollTimeline);
    const [pageTimeline, setPageTimeline] = useState<gsap.core.Timeline>();

    useGSAP(() => {
        if (navigationType !== "scroll" && navigationType !== "scrollCards" && navigationType !== "scrollContinuous") return;
        if (!elRef.current || !scrollerRef?.current) return;

        const pt = gsap.timeline();

        if (scrollTimeline) {
            scrollTimeline.add(pt, 0);
        }

        ScrollTrigger.create({
            trigger: elRef.current,
            scroller: scrollerRef.current,
            start: "top bottom",
            end: "bottom top",
            animation: pt,
            scrub: true,
            onUpdate: () => {
                // console.log(`scrollNavigation: Page ${pageIndex} timeline progress: ${self.progress.toFixed(3)}`);
            }

        });
        setPageTimeline(pt);

    }, { scope: elRef, dependencies: [pageIndex, scrollTimeline, navigationType, isPreviewer, isInPlayWrightTest, isInAuthor, scrollerRef] });
    return pageTimeline;
}

export default useScrollAnimation
